import React from "react";
import SearchSuggestionsQuestions from "../suggestions/questions";
import { Variants } from "../../animations/variants";
import { motion } from "motion/react";
import { ConversationTurnRouting } from "../../types";
import { useConfig } from "../../providers/config_provider";
import { isNoMatch } from "../../lib/routing";

type SearchResultsEmptyProps = {
  routing?: ConversationTurnRouting;
};

export default function SearchResultsEmpty({ routing }: SearchResultsEmptyProps) {
  const { organization } = useConfig();
  const { name } = organization;

  const emptyMessage = isNoMatch(routing)
    ? `It looks like we don't have an answer in the ${name} archives. However, your question has caught our attention and will be shared with the ${name} team.`
    : `We can't find anything on that topic. Do you want to rephrase or try again?`;

  return (
    <div className="dewey--search--section--empty">
      <motion.div
        key="data--empty"
        variants={Variants.FadeInUp}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <p className="dewey--search--empty--message">{emptyMessage}</p>
      </motion.div>
      <motion.div
        key="data--questions"
        variants={Variants.FadeInUpDelayed}
        initial="initial"
        animate="animate"
        exit="exit"
        className="dewey--search--section--motion"
      >
        <SearchSuggestionsQuestions />
      </motion.div>
    </div>
  );
}
